<template>
  <div id="app">
    <component :is="layout" :id="layout" :title="title">
      <router-view />
    </component>
  </div>
</template>
<script>
const defaultLayout = "default";
import Default from "./layouts/DefaultLayout";
import cardbody from "./layouts/CardBody";
import dashboard from "./layouts/DashboardLayout";
import loader from "./components/Loader";
import blank from "./layouts/BlankLayout";
import admin from "./layouts/AdminLayout"
import { videoApi } from "./services/videoApi";
import { mapActions } from "vuex";
export default {
  components: {
    "default-layout": Default,
    "cardbody-layout": cardbody,
    "dashboard-layout": dashboard,
    "blank-layout": blank,
    "admin-layout" : admin ,
    loader: loader
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || defaultLayout) + "-layout";
    },
    title() {
      return this.$route.meta && this.$route.meta.title
        ? this.$route.meta.title
        : "";
    }
  },
  mounted() {
    videoApi
      .getCategory()
      .then(res => {
        this.setCategory(res.data);
      })
      .catch(e => {
        console.error("category api fail", e);
      });

    let loader = this.$loading.show(
      {
        color: "#e80b35",
        width: 64,
        height: 64,
        canCancel: false,
        opacity: 0.9
      },
      {
        default: this.$createElement("loader")
      }
    );
    // simulate AJAX
    setTimeout(() => {
      loader.hide();
    }, 500);
  },
  methods: {
    ...mapActions("category", ["setCategory"])
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="vue-loading-overlay/dist/vue-loading.css"></style>
